import { Component, ElementRef, Input, OnInit, inject } from '@angular/core';

@Component({
  selector: 'bepatient-menu-secondary-button-container',
  templateUrl: './menu-secondary-button-container.component.html',
  styleUrls: ['./menu-secondary-button-container.component.scss'],
  standalone: false
})
export class MenuSecondaryButtonContainerComponent implements OnInit {
  private elementRef = inject(ElementRef);

  @Input() title: string;
  @Input() color: string;

  ngOnInit() {
    this.elementRef.nativeElement.style.setProperty(
      '--data-menu-color',
      this.color
    );
  }
}
